import React from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function ProtectedCustomer({ children }) {
  const { customerToken } = useApp();
  if (!customerToken) return <Navigate to="/account/login" replace />;
  return children;
}
